<template>
  <v-card class="main-content-card" id="inte-intellectualCheck-card">
    <v-toolbar flat>
      <v-toolbar-title>到款认领审核</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <basic :incoBasic="item"/>
        </v-flex>
        <v-flex xs12>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="item.status.color"
                    @click="() => { history=item.history; hist = true; }">
              {{ item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { reviewDbid = item.pznm; reviewFlbh = item.flbh; reviewMsg = item.pznm; reviewActs = item.actions; review = true; }"
                   :disabled="reviewDisabled(item)">
              <v-icon color="teal">playlist_add_check</v-icon>
            </v-btn>
            <span>审核</span>
          </v-tooltip>
          <x-review
              v-model="review"
              :dbid="reviewDbid"
              :flbh="reviewFlbh"
              :message="reviewMsg"
              :uri="uri"
              :actions="reviewActs"
              @ok="(it) => {$router.push('/proj/incoclaim/index')}"
          />

          <x-history
              v-model="hist"
              :history="history"
              :status="statusItems"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import Basic from './basic'
import XReview from '@/components/global/ReviewClaim'
import XHistory from '@/components/global/History'

const baseUri = '/api/proj/incoclaim';
const statusUri = '/api/code/status';

export default {
  components: {Basic, XReview, XHistory},
  data: () => ({
    uri: baseUri,
    item: {
      histories: [],
      status: {},
      actions: []
    },

    statusItems: [],

    review: false,
    reviewDbid: null,
    reviewFlbh: null,
    reviewMsg: null,
    reviewActs: [],

    hist: false,
    history: [],
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    window.console.log("In edit_page beforeRouteEnter");
    const dbid = to.params.dbid.substring(0, to.params.dbid.indexOf("&"));
    const flbh = to.params.dbid.substring(to.params.dbid.indexOf("&") + 1, to.params.dbid.length);
    if (dbid.length > 0 & flbh.length > 0) {
      Vue.axios.get(`${baseUri}/check/${dbid}` + `?flbh=${flbh}`)
          .then(
              rsp => next(vm => {
                vm.dbid = dbid;
                vm.item = rsp.data;
                // 保存默认数据
                vm.defaultItem = window.xutil.clone(vm.item);
                vm.loading = false
              })
          )
    } else {
      next();
    }
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {
    window.console.log("In edit_page beforeRouteUpdate");
    const dbid = to.params.dbid.substring(0, to.params.dbid.indexOf("&"));
    const flbh = to.params.dbid.substring(to.params.dbid.indexOf("&") + 1, to.params.dbid.length);
    if (dbid.length > 0 & flbh.length > 0) {
      this.loading = true;
      Vue.axios.get(`${baseUri}/check/${dbid}` + `?flbh=${flbh}`)
          .then(
              rsp => {
                this.dbid = dbid;
                this.item = rsp.data;
                // 保存默认数据
                this.defaultItem = window.xutil.clone(this.item);
                this.loading = false;
                next()
              }
          )
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters(['funcIds'])
  },

  created() {
    // 加载审核状态
    this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
        .then(
            rspStaus => {
              this.statusItems = rspStaus.data.items;
            }
        )
  },

  methods: {
    reviewDisabled(item) {
      return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('c_lkxx_review')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
    }
  }
}
</script>
<style>
div.dense table.datatable.table td:first-child,
div.dense table.datatable.table td:not(:first-child),
div.dense table.datatable.table th:first-child,
div.dense table.datatable.table th:not(:first-child) {
  padding: 0 8px;
}
</style>